if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '0px 0px 400px 0px' });
        }
      }

      init() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) return;

            const recommendations = sectionInnerHTML.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;

              // Ensure recommendations are loaded before overriding
              // setTimeout(() => {
                // this.overrideRecommendedProduct();
              // }, 500); // Wait 500ms to ensure Shopify loads content
            }

            if (recommendations.querySelector('.product-card')) {
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else {
              if (recommendations.classList.contains('complementary-products')) {
                this.closest('.product__block').remove();
              } else {
                this.closest('.shopify-section').remove();
              }
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }

      // overrideRecommendedProduct() {
      //   const currentPath = window.location.pathname;
      //   console.log("Current Product URL:", currentPath); // Debugging

      //   let recommendedProduct = {
      //     title: "Cool Mint Zuum Energy Gum",
      //     price: "$12.99",
      //     url: "/products/cool-mint-zuum-energy-gum"
      //   };

      //   if (currentPath.includes("cool-mint-zuum-energy-gum")) {
      //     recommendedProduct = {
      //       title: "Watermelon Zuum Energy Gum",
      //       price: "$12.99",
      //       url: "/products/watermelon-zuum-energy-gum"
      //     };
      //   } else if (
      //     currentPath.includes("watermelon-zuum-energy-gum") || 
      //     currentPath.includes("spearmint-zuum-energy-gum") || 
      //     currentPath.includes("zuum-starter-pack") || 
      //     currentPath.includes("super-bundle")
      //   ) {
      //     recommendedProduct = {
      //       title: "Cool Mint Zuum Energy Gum",
      //       price: "$12.99",
      //       url: "/products/cool-mint-zuum-energy-gum"
      //     };
      //   }

      //   // Find and update the recommended product
      //   const productCard = this.querySelector('.product-card');
      //   if (productCard) {
      //     console.log("Updating Recommended Product to:", recommendedProduct); // Debugging
      //     productCard.querySelector('.product-card__title').innerText = recommendedProduct.title;
      //     productCard.querySelector('.product-card__price').innerText = recommendedProduct.price;
      //     productCard.querySelector('a').href = recommendedProduct.url;
      //   } else {
      //     console.log("No product card found!"); // Debugging
      //   }
      // }
    }
  );
}
